import { createRouter, createWebHistory } from "vue-router";
import { handleHotUpdate, routes } from "vue-router/auto-routes";
import type { Requirement } from "@/lib/access";

declare module "vue-router" {
  interface RouteMeta {
    /** Hide / refuse the page unless the signed-in user meets this. */
    requires?: Requirement;
    /** Page title (browser tab). */
    title?: string;
    /** Full-bleed page without the max-width container. */
    wide?: boolean;
  }
}

export const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, saved) {
    if (saved) return saved;
    if (to.hash) return { el: to.hash, top: 80, behavior: "smooth" };
    if (to.path === from.path) return false;
    return { top: 0 };
  },
});

router.afterEach((to) => {
  document.title = to.meta.title ? `${to.meta.title} · Smake` : "Smake";
});

if (import.meta.hot) handleHotUpdate(router);
